import List from "../../containers/Seo/List";
import Entry from "../../containers/Seo";

const seoRoutes = [
  {
    path: "/seo",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/seo/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/seo/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default seoRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/seo.jsx